import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";

import { IFilterCheckboxInputProps } from "../interfaces/filter-interfaces";
import { memoFilter } from "./memoFilter";

// table header filter component, you send it in the column as filterBody prop
// eg. (filterBody: (inputData: IPrimeFilterData) => <MemoFilterCheckboxInput inputData={inputData} />)
export const MemoFilterCheckboxInput = memoFilter((props: IFilterCheckboxInputProps) => {
    const { column, isFilterDisabled } = props.inputData;

    if (isFilterDisabled) return <DisabledFilterSelectInput field={column.field} />;

    return <FilterSelectInput {...props} />;
});

export const FilterSelectInput = ({ inputData, placeholder, clearable = true, customFilterChoices }: IFilterCheckboxInputProps) => {
    const { t } = useTranslation();
    const { column, onFilterChange, filter } = inputData;

    const choices = (customFilterChoices ?? [
        { label: "Selected", value: "True" },
        { label: "Not selected", value: "False" },
    ]).map((o) => ({ ...o, label: t(o.label) }));

    return (
        <div key={`prime-checkbox-input-${column.field}-container`} className="table-filter">
            <Dropdown
                key={`prime-checkbox-input-${column.field}`}
                className="table-filter prime-table-filter-input-font filter-select"
                name={column.filterField}
                value={filter?.value}
                options={choices}
                onChange={(e) => onFilterChange({ filterField: column.filterField, field: column.field, value: e.target.value }, "__exact")}
                optionLabel="label"
                optionValue="value"
                placeholder={placeholder ? t(placeholder) : `${t("Filter")} ${t(column.header)}`}
                showClear={clearable}
            />
        </div>
    );
};

interface IDisabledFilterSelectInput {
    field: string;
}

export const DisabledFilterSelectInput = ({ field }: IDisabledFilterSelectInput) => {
    const { t } = useTranslation();

    return (
        <div key={`prime-checkbox-input-${field}-container-disabled`} className="filter-select-input-container">
            <Dropdown
                key={`prime-checkbox-input-${field}-disabled`}
                className="table-filter prime-table-filter-input-font"
                placeholder={t("Advanced filter...")}
                disabled
            />
        </div>
    );
};
